import React from 'react';

const NoAccess = () => (
  <div className="row no-gutters h-100 align-items-center justify-content-center">
    You do not have proper privileges assigned. Please contact Administrators.
  </div>
);

export default NoAccess;
